module.exports = __webpack_public_path__ + "img/HA2515-198.46dde157.jpg";